module.exports = __webpack_public_path__ + "img/examples-en-3.6f9310aa.jpg";